import { ThumbnailInfo } from '@app/core/hooks/api/useApiThumbnailsRange';
import { Segment } from '@mi-front/core';
import { TimestampedThumbnail } from '@mi-front/ui';
import { useMemo } from 'react';

/**
 * Joins fetched thumbnails with segment timestamps for a time-aligned filmstrip.
 */
export function useTimestampedThumbnails(
  thumbnails: ThumbnailInfo[],
  segments: Segment[],
): TimestampedThumbnail[] {
  return useMemo(() => {
    const segmentById = new Map(segments.map((segment) => [segment.id, segment]));

    return thumbnails
      .map((thumbnail) => {
        const segment = segmentById.get(thumbnail.segmentId);
        if (!segment) return null;

        return {
          ...thumbnail,
          startTs: segment.startTs,
        };
      })
      .filter((thumbnail): thumbnail is TimestampedThumbnail => thumbnail !== null)
      .sort((a, b) => a.startTs - b.startTs);
  }, [thumbnails, segments]);
}
